/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { errorPayoutConfig } from '@/pages/PayoutPage/config/error.config';

export interface IErrorPayoutListPluginMethods extends IPluginMethodMap {
  getErrorPayoutListSync(args?: any): any;
}

export class ErrorPayoutListPlugin implements IAgentPlugin {
  readonly methods: IErrorPayoutListPluginMethods;

  constructor() {
    this.methods = {
      getErrorPayoutListSync: this.getErrorPayoutListSync.bind(this),
    };
  }

  getErrorPayoutListSync(args?: any) {
    return {
      error: errorPayoutConfig,
    };
  }
}
